import ShiftsReport from "./ShiftsReport";

export default ShiftsReport;
